import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"

import TestimonialSlide from "components/testimonial-gallery/slide"

const ContentfulTestimonialSlide = ({ elRef, component, onTop, nested }) => {
  const {
    excerpt,
    text,
    attribution,
    attributionName,
    attributionTitle,
    attributionImage,
    backgroundColor,
    hideOnPageLoad,
    id,
  } = component

  return (
    <ThemeProvider theme={componentThemeExtension(backgroundColor, nested, onTop)}>
      <TestimonialSlide
        dataId={id}
        hideOnPageLoad={hideOnPageLoad}
        elRef={elRef}
        text={text.childMarkdownRemark.html}
        excerpt={excerpt && excerpt.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")}
        image={
          (attribution && attribution.image[0].secure_url) ||
          (attributionImage && attributionImage[0].secure_url)
        }
        author={(attribution && attribution.name) || attributionName}
        credentials={(attribution && attribution.personTitle) || attributionTitle}
      />
    </ThemeProvider>
  )
}

export default ContentfulTestimonialSlide
